import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";
import styles from "./Icon.module.scss";
import { SvgImage } from "./_dependencies";
import { IIconProps } from "./types";

export const Icon: FunctionComponent<IIconProps> = (
  props: IIconProps
): ReactElement<IIconProps> => {
  const {
    backgroundColor,
    children,
    className,
    color,
    icon,
    iconStyle,
    size,
    ...restProps
  } = props;

  return (
    <div
      className={classNames(styles.containerDefault, className)}
      style={{
        backgroundColor,
        height: size,
        maxHeight: size,
        maxWidth: size,
        minHeight: size,
        minWidth: size,
        width: size,
      }}
      {...restProps}
    >
      {children}
      <SvgImage color={color} icon={icon} size={22} style={iconStyle} />
    </div>
  );
};
